<template>
  <v-dialog v-model="dialog" max-width="900">
    <template v-if="isNew" #activator="{ on, attrs }">
      <mf-button v-bind="attrs" color="primary" label="Adicionar Atributo Dinâmico" v-on:click.native="on.click" />
    </template>
    <mf-card-container
      :title="isNew ? 'Adicionar Atributo Dinâmico' : 'Editar Atributo Dinâmico'"
      :description="isNew ? 'Adicione um novo atributo dinâmico do tipo dados extras do usuário.' : 'Edite a configuração do atributo dinâmico.'"
    >
      <v-row>
        <v-col cols="3">
          <v-text-field v-model="$v.dynamicAttribute.label.$model" label="Label" outlined hide-details :error-messages="errorMessages.label" />
        </v-col>
        <v-col cols="3">
          <v-text-field :value="attribute" label="Nome do atributo" outlined hide-details disabled :error-messages="isNew ? errorMessages.attribute : []" />
        </v-col>
        <v-col cols="3">
          <v-select
            v-model="$v.dynamicAttribute.type.$model"
            :items="typeOptions"
            item-text="label"
            item-value="key"
            label="Tipo"
            outlined
            hide-details
            :disabled="!isNew"
            :error-messages="errorMessages.type"
          />
        </v-col>
        <v-col v-if="dynamicAttribute.type === 'OPTIONS'" cols="3" class="d-flex align-center">
          <configure-dynamic-attribute-options v-model="dynamicAttribute.options" :error="hasOptionsError" />
        </v-col>
      </v-row>

      <v-expansion-panels class="mb-4">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="card-title-font">Configuração do Hotsite</span>
            <v-spacer />
            <div class="d-flex align-center justify-end">
              <mf-icon
                :icon="dynamicAttribute.availableOnHotsite ? 'check_circle' : 'cancel'"
                :color="dynamicAttribute.availableOnHotsite ? 'verde-l20' : 'vermelho-l20'"
                size="sm"
              />
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row align="center">
              <v-col cols="2">
                <v-checkbox v-model="dynamicAttribute.availableOnHotsite" label="Disponível" hide-details dense class="mt-0" />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="$v.dynamicAttribute.hotsiteConfig.label.$model"
                  label="Label"
                  dense
                  outlined
                  hide-details
                  :disabled="!dynamicAttribute.availableOnHotsite"
                  :error-messages="dynamicAttribute.availableOnHotsite ? errorMessages['hotsiteConfig.label'] : []"
                />
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  v-model="dynamicAttribute.hotsiteConfig.personTypeNatural"
                  label="Pessoa Física"
                  hide-details
                  dense
                  class="mt-0"
                  :disabled="!dynamicAttribute.availableOnHotsite"
                />
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  v-model="dynamicAttribute.hotsiteConfig.personTypeLegal"
                  label="Pessoa Jurídica"
                  hide-details
                  dense
                  class="mt-0"
                  :disabled="!dynamicAttribute.availableOnHotsite"
                />
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="2">
                <v-checkbox
                  v-model="dynamicAttribute.hotsiteConfig.mandatory"
                  label="Obrigatório"
                  hide-details
                  dense
                  class="mt-0"
                  :disabled="!dynamicAttribute.availableOnHotsite"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="dynamicAttribute.hotsiteConfig.hotsiteSlotIds"
                  :items="hotsiteSlotsOptions"
                  item-text="name"
                  item-value="_id"
                  label="Hotsites"
                  outlined
                  hide-details
                  multiple
                  chips
                  dense
                  :disabled="!dynamicAttribute.availableOnHotsite"
                  :error-messages="dynamicAttribute.availableOnHotsite ? errorMessages['hotsiteConfig.hotsiteSlotIds'] : []"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-expansion-panels class="mb-4">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <span class="card-title-font">Configuração do App</span>
            <v-spacer />
            <div class="d-flex align-center justify-end">
              <mf-icon
                :icon="dynamicAttribute.availableOnApp ? 'check_circle' : 'cancel'"
                :color="dynamicAttribute.availableOnApp ? 'verde-l20' : 'vermelho-l20'"
                size="sm"
              />
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row align="center">
              <v-col cols="2">
                <v-checkbox v-model="dynamicAttribute.availableOnApp" label="Disponível" hide-details dense class="mt-0" />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="$v.dynamicAttribute.appConfig.label.$model"
                  label="Label"
                  dense
                  outlined
                  hide-details
                  :disabled="!dynamicAttribute.availableOnApp"
                  :error-messages="dynamicAttribute.availableOnApp ? errorMessages['appConfig.label'] : []"
                />
              </v-col>
              <v-col cols="3" class="py-0">
                <v-checkbox
                  v-model="dynamicAttribute.appConfig.personTypeNatural"
                  label="Pessoa Física"
                  hide-details
                  dense
                  class="mt-0"
                  :disabled="!dynamicAttribute.availableOnApp"
                />
              </v-col>
              <v-col cols="3" class="py-0">
                <v-checkbox
                  v-model="dynamicAttribute.appConfig.personTypeLegal"
                  label="Pessoa Jurídica"
                  hide-details
                  dense
                  class="mt-0"
                  :disabled="!dynamicAttribute.availableOnApp"
                />
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="2" class="py-0">
                <v-checkbox
                  v-model="dynamicAttribute.appConfig.mandatory"
                  label="Obrigatório"
                  hide-details
                  dense
                  class="mt-0"
                  :disabled="!dynamicAttribute.availableOnApp"
                />
              </v-col>
              <v-col cols="2" class="py-0">
                <v-text-field
                  v-model.number="$v.dynamicAttribute.appConfig.order.$model"
                  label="Ordem"
                  type="number"
                  dense
                  outlined
                  hide-details
                  :disabled="!dynamicAttribute.availableOnApp"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <mf-action-buttons
        :primary-button="{
          text: isNew ? 'Adicionar' : 'Salvar',
          action: saveDynamicAttribute,
          isVisible: true,
          isLoading: loading,
        }"
        :secondary-button="{
          text: 'Cancelar',
          action: cancel,
          isVisible: true,
          isDisabled: loading,
        }"
      />
    </mf-card-container>
  </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'
import { DYNAMIC_ATTRIBUTE_TYPES, DYNAMIC_ATTRIBUTES_TYPES_TO_COMPONENTS } from '@/modules/configuracoes/site-de-cadastramento/constants/dynamicAttributes'

export default {
  name: 'ConfigureDynamicAttribute',
  components: {
    ConfigureDynamicAttributeOptions: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/ConfigureDynamicAttributeOptions.vue'),
  },
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
    initialDynamicAttribute: {
      type: Object,
      default: null,
    },
    saveDynamicAttributeFn: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      localDynamicAttribute: null,
      dynamicAttribute: {
        label: '',
        type: '',
        options: [],
        availableOnHotsite: false,
        availableOnApp: false,
        hotsiteConfig: {
          label: '',
          mandatory: false,
          personTypeNatural: false,
          personTypeLegal: false,
          hotsiteSlotIds: [],
        },
        appConfig: {
          label: '',
          mandatory: false,
          order: 0,
          personTypeNatural: false,
          personTypeLegal: false,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['hotsiteSlots']),
    typeOptions() {
      return DYNAMIC_ATTRIBUTE_TYPES.filter((type) => ['INTEGER', 'OPTIONS', 'BOOLEAN'].includes(type.key))
    },
    hotsiteSlotsOptions() {
      return this.hotsiteSlots || []
    },
    hasOptionsError() {
      if (this.dynamicAttribute.type !== 'OPTIONS') return false
      if (!this.$v.dynamicAttribute.options) return false
      return this.$v.dynamicAttribute.options.$error && (this.$v.dynamicAttribute.options.$dirty || this.$v.$anyDirty)
    },
    attribute() {
      const attr = this.initialDynamicAttribute || this.localDynamicAttribute
      if (!this.isNew && attr) {
        return attr.attribute
      }
      return this.generateAttributeFromLabel(this.dynamicAttribute.label)
    },
    errorMessages() {
      const errors = {}
      if (this.$v.dynamicAttribute.label && this.$v.dynamicAttribute.label.$error) {
        if (this.$v.dynamicAttribute.label.required === false) errors.label = 'Campo obrigatório'
      } else {
        errors.label = ''
      }

      if (this.isNew && this.$v.dynamicAttribute.attribute && this.$v.dynamicAttribute.attribute.$error) {
        if (this.$v.dynamicAttribute.attribute.required === false) errors.attribute = 'Campo obrigatório'
      } else {
        errors.attribute = ''
      }

      if (this.$v.dynamicAttribute.type && this.$v.dynamicAttribute.type.$error) {
        if (this.$v.dynamicAttribute.type.required === false) errors.type = 'Campo obrigatório'
      } else {
        errors.type = ''
      }

      if (this.$v.dynamicAttribute.hotsiteConfig && this.$v.dynamicAttribute.hotsiteConfig.label && this.$v.dynamicAttribute.hotsiteConfig.label.$error) {
        if (this.$v.dynamicAttribute.hotsiteConfig.label.required === false) errors['hotsiteConfig.label'] = 'Campo obrigatório'
      } else {
        errors['hotsiteConfig.label'] = ''
      }

      if (
        this.$v.dynamicAttribute.hotsiteConfig &&
        this.$v.dynamicAttribute.hotsiteConfig.hotsiteSlotIds &&
        this.$v.dynamicAttribute.hotsiteConfig.hotsiteSlotIds.$error
      ) {
        if (this.$v.dynamicAttribute.hotsiteConfig.hotsiteSlotIds.required === false)
          errors['hotsiteConfig.hotsiteSlotIds'] = 'Selecione pelo menos um hotsite slot'
      } else {
        errors['hotsiteConfig.hotsiteSlotIds'] = ''
      }

      if (this.$v.dynamicAttribute.appConfig && this.$v.dynamicAttribute.appConfig.label && this.$v.dynamicAttribute.appConfig.label.$error) {
        if (this.$v.dynamicAttribute.appConfig.label.required === false) errors['appConfig.label'] = 'Campo obrigatório'
      } else {
        errors['appConfig.label'] = ''
      }

      return errors
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal && !this.isNew) {
        const attr = this.initialDynamicAttribute || this.localDynamicAttribute
        if (attr) {
          this.loadDynamicAttribute(attr)
        }
      } else if (!newVal) {
        this.resetForm()
      }
    },
    initialDynamicAttribute: {
      handler(newVal) {
        if (newVal && this.dialog && !this.isNew) {
          this.loadDynamicAttribute(newVal)
        }
      },
      immediate: true,
    },
    'dynamicAttribute.type'(newType) {
      if (newType !== 'OPTIONS') {
        this.dynamicAttribute.options = []
      }
    },
    'dynamicAttribute.availableOnHotsite'(newVal) {
      if (newVal && !this.dynamicAttribute.hotsiteConfig.label) {
        this.dynamicAttribute.hotsiteConfig.label = this.dynamicAttribute.label
      }
    },
    'dynamicAttribute.availableOnApp'(newVal) {
      if (newVal && !this.dynamicAttribute.appConfig.label) {
        this.dynamicAttribute.appConfig.label = this.dynamicAttribute.label
      }
    },
    'dynamicAttribute.label'(newLabel, oldLabel) {
      console.log('oldLabel', oldLabel)
      console.log(this.dynamicAttribute.hotsiteConfig.label)
      if (this.dynamicAttribute.availableOnHotsite && (!this.dynamicAttribute.hotsiteConfig.label || oldLabel === this.dynamicAttribute.hotsiteConfig.label)) {
        this.dynamicAttribute.hotsiteConfig.label = newLabel
      }
      if (this.dynamicAttribute.availableOnApp && (!this.dynamicAttribute.appConfig.label || oldLabel === this.dynamicAttribute.appConfig.label)) {
        this.dynamicAttribute.appConfig.label = newLabel
      }
    },
  },
  mounted() {
    this.queryHotsiteSlots()
  },
  methods: {
    ...mapActions(['queryHotsiteSlots']),
    generateAttributeFromLabel(label) {
      if (!label) return ''
      return label
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9_]/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_|_$/g, '')
    },
    loadDynamicAttribute(attr) {
      const dynamicAttribute = attr || this.initialDynamicAttribute || this.localDynamicAttribute
      if (!dynamicAttribute) return
      this.dynamicAttribute.label = dynamicAttribute.label || ''
      this.dynamicAttribute.type = dynamicAttribute.type || ''
      this.dynamicAttribute.options = dynamicAttribute.options ? [...dynamicAttribute.options] : []
      this.dynamicAttribute.availableOnHotsite = dynamicAttribute.available_on_hotsite || false
      this.dynamicAttribute.availableOnApp = dynamicAttribute.available_on_app || false

      if (dynamicAttribute.app_configuration) {
        const allowedTypes = dynamicAttribute.app_configuration.allowed_person_types || []
        this.dynamicAttribute.appConfig = {
          label: dynamicAttribute.app_configuration.label || '',
          mandatory: dynamicAttribute.app_configuration.mandatory || false,
          order: dynamicAttribute.app_configuration.order || 0,
          personTypeNatural: allowedTypes.includes('N'),
          personTypeLegal: allowedTypes.includes('L'),
        }
      } else if (this.dynamicAttribute.availableOnApp) {
        this.dynamicAttribute.appConfig.label = this.dynamicAttribute.label
      }

      if (dynamicAttribute.hotsite_configuration) {
        const allowedTypes = dynamicAttribute.hotsite_configuration.allowed_person_types || []
        this.dynamicAttribute.hotsiteConfig = {
          label: dynamicAttribute.hotsite_configuration.label || '',
          mandatory: dynamicAttribute.hotsite_configuration.mandatory || false,
          personTypeNatural: allowedTypes.includes('N'),
          personTypeLegal: allowedTypes.includes('L'),
          hotsiteSlotIds: (dynamicAttribute.hotsite_configuration.hotsite_slots || []).map((slot) => slot._id),
        }
      } else if (this.dynamicAttribute.availableOnHotsite && !this.dynamicAttribute.hotsiteConfig.label) {
        this.dynamicAttribute.hotsiteConfig.label = this.dynamicAttribute.label
      }
    },
    open(dynamicAttribute) {
      this.localDynamicAttribute = dynamicAttribute
      this.dialog = true
    },
    cancel() {
      this.dialog = false
      this.resetForm()
    },
    resetForm() {
      this.dynamicAttribute = {
        label: '',
        type: '',
        options: [],
        availableOnHotsite: false,
        availableOnApp: false,
        hotsiteConfig: {
          label: '',
          mandatory: false,
          personTypeNatural: false,
          personTypeLegal: false,
          hotsiteSlotIds: [],
        },
        appConfig: {
          label: '',
          mandatory: false,
          order: 0,
          personTypeNatural: false,
          personTypeLegal: false,
        },
      }
      this.$v.$reset()
    },
    async saveDynamicAttribute() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.loading = true
      try {
        const variables = {
          attribute: this.attribute.trim(),
          label: this.dynamicAttribute.label.trim(),
          type: this.dynamicAttribute.type,
          origin: 'USER_EXTRA_DATA',
        }

        if (this.dynamicAttribute.type === 'OPTIONS' && this.dynamicAttribute.options.length > 0) {
          variables.options = this.dynamicAttribute.options.map((opt) => ({
            label: opt.label.trim(),
            value: opt.value.trim(),
          }))
        }

        if (this.dynamicAttribute.availableOnHotsite) {
          const allowedPersonTypes = []
          if (this.dynamicAttribute.hotsiteConfig.personTypeNatural) allowedPersonTypes.push('N')
          if (this.dynamicAttribute.hotsiteConfig.personTypeLegal) allowedPersonTypes.push('L')

          variables.hotsite_configuration = {
            label: this.dynamicAttribute.hotsiteConfig.label.trim(),
            type: DYNAMIC_ATTRIBUTES_TYPES_TO_COMPONENTS[this.dynamicAttribute.type],
            mandatory: this.dynamicAttribute.hotsiteConfig.mandatory,
            allowed_person_types: allowedPersonTypes,
            options:
              this.dynamicAttribute.type === 'OPTIONS' && this.dynamicAttribute.options.length > 0
                ? this.dynamicAttribute.options.map((opt) => ({
                    label: opt.label.trim(),
                    value: opt.value.trim(),
                  }))
                : [],
            hotsite_slots:
              this.dynamicAttribute.hotsiteConfig.hotsiteSlotIds && this.dynamicAttribute.hotsiteConfig.hotsiteSlotIds.length > 0
                ? this.dynamicAttribute.hotsiteConfig.hotsiteSlotIds
                : [],
          }
        }

        if (this.dynamicAttribute.availableOnApp) {
          const allowedPersonTypes = []
          if (this.dynamicAttribute.appConfig.personTypeNatural) allowedPersonTypes.push('N')
          if (this.dynamicAttribute.appConfig.personTypeLegal) allowedPersonTypes.push('L')

          variables.app_configuration = {
            name: this.attribute.trim(),
            label: this.dynamicAttribute.appConfig.label.trim(),
            type: DYNAMIC_ATTRIBUTES_TYPES_TO_COMPONENTS[this.dynamicAttribute.type],
            mandatory: this.dynamicAttribute.appConfig.mandatory,
            order: this.dynamicAttribute.appConfig.order || 0,
            allowed_person_types: allowedPersonTypes,
            options:
              this.dynamicAttribute.type === 'OPTIONS' && this.dynamicAttribute.options.length > 0
                ? this.dynamicAttribute.options.map((opt) => ({
                    label: opt.label.trim(),
                    value: opt.value.trim(),
                  }))
                : [],
          }
        }

        variables.available_on_hotsite = this.dynamicAttribute.availableOnHotsite
        variables.available_on_app = this.dynamicAttribute.availableOnApp

        const attr = this.initialDynamicAttribute || this.localDynamicAttribute
        if (!this.isNew && attr) {
          variables._id = attr._id
        }

        await this.saveDynamicAttributeFn(variables)
        this.dialog = false
        this.resetForm()
      } catch (error) {
        console.error(error)
        this.$snackbar({
          message: this.isNew ? 'Erro ao criar novo atributo dinâmico.' : 'Erro ao salvar atributo dinâmico.',
          snackbarColor: 'error',
        })
      } finally {
        this.loading = false
      }
    },
  },
  validations() {
    const validations = {
      dynamicAttribute: {
        label: { required },
        type: { required },
        options: {},
        availableOnHotsite: {},
        availableOnApp: {},
        hotsiteConfig: {
          label: {
            required: this.dynamicAttribute.availableOnHotsite ? required : () => true,
          },
          hotsiteSlotIds: {
            required: this.dynamicAttribute.availableOnHotsite
              ? () => this.dynamicAttribute.hotsiteConfig.hotsiteSlotIds && this.dynamicAttribute.hotsiteConfig.hotsiteSlotIds.length > 0
              : () => true,
          },
          mandatory: {},
          personTypeNatural: {},
          personTypeLegal: {},
        },
        appConfig: {
          label: {
            required: this.dynamicAttribute.availableOnApp ? required : () => true,
          },
          mandatory: {},
          order: {},
          personTypeNatural: {},
          personTypeLegal: {},
        },
      },
    }

    if (this.isNew) {
      validations.dynamicAttribute.attribute = {
        required: () => !!this.attribute.trim(),
      }
    }

    if (this.dynamicAttribute.type === 'OPTIONS') {
      validations.dynamicAttribute.options = {
        required: () => this.dynamicAttribute.options.length > 0,
        $each: {
          label: { required },
          value: { required },
        },
      }
    }

    return validations
  },
}
</script>
